// extracted by mini-css-extract-plugin
module.exports = {"paramTitle":"paramTitle_3U82c","firstContent":"firstContent_2fqep","paramAutoStartContent":"paramAutoStartContent_3jjqY","title":"title_2LK4F"};